import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const UnauthorizedPage = () => {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth); // Redux store

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <div style={styles.icon}>🚫</div>
        <h1 style={styles.title}>Access Denied</h1>
        <p style={styles.message}>
          You don't have permission to access this page.
        </p>
        <p style={styles.subMessage}>
          Current role: <strong>{user?.role || 'Unknown'}</strong>
        </p>
        <div style={styles.actions}>
          <button 
            style={styles.backButton}
            onClick={() => navigate(-1)}
          >
            ← Go Back
          </button>
          <Link to="/dashboard" style={styles.dashboardLink}>
            Go to Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '80vh',
    backgroundColor: '#f8fafc',
    padding: '2rem'
  },
  content: {
    backgroundColor: 'white',
    padding: '3rem',
    borderRadius: '12px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    textAlign: 'center',
    maxWidth: '500px'
  },
  icon: {
    fontSize: '4rem',
    marginBottom: '1rem'
  },
  title: {
    color: '#dc2626',
    marginBottom: '1rem',
    fontSize: '2rem'
  },
  message: {
    color: '#6b7280',
    marginBottom: '0.5rem',
    fontSize: '1.1rem'
  },
  subMessage: {
    color: '#9ca3af',
    marginBottom: '2rem',
    fontSize: '0.9rem'
  },
  actions: {
    display: 'flex',
    gap: '1rem',
    justifyContent: 'center',
    flexWrap: 'wrap'
  },
  backButton: {
    backgroundColor: '#6b7280',
    color: 'white',
    border: 'none',
    padding: '0.75rem 1.5rem',
    borderRadius: '8px',
    cursor: 'pointer',
    textDecoration: 'none',
    fontSize: '1rem'
  },
  dashboardLink: {
    backgroundColor: '#3b82f6',
    color: 'white',
    padding: '0.75rem 1.5rem',
    borderRadius: '8px',
    textDecoration: 'none',
    fontSize: '1rem'
  }
};

export default UnauthorizedPage;
